const EventSubscriber = () => {
  const eventTracker = {};
  const subscribe = (name, eventHandler) => {
    eventTracker[name] = eventHandler;
    return name;
  };
  const unsubscribe = name => {
    delete eventTracker[name];
  };
  const getEvent = name => eventTracker[name];
  const checkSubscription = name => typeof eventTracker[name] !== 'undefined';
  const evoke = (name, ...props) => {
    if (typeof eventTracker[name] === 'undefined') {
      throw new Error(`Could not evoke event. Event of name [${name}] is not being tracked.`);
    }
    return eventTracker[name](...props);
  };
  return {
    getEvent,
    subscribe,
    unsubscribe,
    checkSubscription,
    evoke
  };
};
export default EventSubscriber;
//# sourceMappingURL=EventSubscriber.js.map